module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"heatingHeading":"Heizungsersatz","nameTitle":"Energieträger","initialTitle":"Initialkosten","perKwTitle":"Leistungsabhängig"}}')
  delete Component.options._Ctor
}
